import { reactive, openBlock, createElementBlock, normalizeClass, Fragment, renderList, normalizeStyle, computed, createCommentVNode, ref, watch, onMounted, onActivated, onDeactivated, onBeforeUnmount, h, Comment, cloneVNode, nextTick } from 'vue';
import { createComponent } from './utils/create-component';
import propTypes from './utils/prop-types';
import { CHANGE_EVENT, DOM_CHANGE_EVENT, FOLLOW_CHANGE_EVENT, NEXT_FOLLOW_CHANGE_EVENT } from './utils/constants';
import useTouch from './utils/hooks/use-touch';
import { useExpose } from './utils/hooks';
import { flatVnodes } from './utils/vnode';
import { preventDefault } from './utils/dom';

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

var props = {
  // 是否自动播放
  autoPlay: propTypes["boolean"]().def(false),
  // 自动播放间隔
  interval: propTypes.number().def(4000),
  // 动画时长
  duration: propTypes.number().def(500),
  // 是否循环滚动
  loop: propTypes["boolean"]().def(false),
  // 默认展示索引
  initIndex: propTypes.number().def(0),
  // 内置指示器（支持现有两种场景）
  indicator: propTypes.string().def('common'),
  indicatorShow: propTypes["boolean"]().def(true),
  // 指示器是否单独在轮播图下占据空间
  indicatorSpace: propTypes["boolean"]().def(false),
  // 指示器位置(左中右)
  indicatorPlacement: propTypes.string().def('right'),
  // 内置指示器颜色
  indicatorColor: propTypes.string(),
  // 内置指示器激活颜色
  indicatorActiveColor: propTypes.string(),
  // 阻止冒泡
  isStopPropagation: propTypes["boolean"]().def(false),
  // 阻止默认事件
  isPreventDefault: propTypes["boolean"]().def(false),
  // 是否可以触摸
  touchable: propTypes["boolean"]().def(true),
  // class注入
  indicatorWrapperClass: propTypes.string(),
  // 容器外的部分是否隐藏
  isOverflowHidden: propTypes["boolean"]().def(true),
  // 跟手动效配置
  followConfig: propTypes.object().def({
    isFollow: false
  })
};
var emits = [CHANGE_EVENT, DOM_CHANGE_EVENT, FOLLOW_CHANGE_EVENT, NEXT_FOLLOW_CHANGE_EVENT];

function useTimer(_ref) {
  var time = _ref.time,
    fn = _ref.fn;
  var state = reactive({
    timer: -1
  });
  function run() {
    state.timer = window.setTimeout(function () {
      fn();
      run();
    }, time);
  }
  function start() {
    clearTimeout(state.timer);
    run();
  }
  function stop() {
    clearTimeout(state.timer);
  }
  /* istanbul ignore next */
  function once() {
    stop();
    fn();
  }
  return {
    state: state,
    start: start,
    stop: stop,
    once: once
  };
}

var _createComponent$2 = createComponent('swiper-indicator-common'),
  create$2 = _createComponent$2.create,
  className$2 = _createComponent$2.className;
var script$2 = create$2({
  props: {
    // 当前索引
    current: propTypes.number().def(0),
    // 总数
    count: propTypes.number().def(0),
    // 指示器颜色
    color: propTypes.string().def('rgba(255, 255, 255, 0.5)'),
    // 指示器激活颜色
    activeColor: propTypes.string().def('#fff')
  },
  setup: function setup() {
    return {
      className: className$2
    };
  }
});

function render$1(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", {
    "class": normalizeClass(_ctx.className)
  }, [(openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.count, function (value, index) {
    var _normalizeClass2;
    return openBlock(), createElementBlock("div", {
      key: index,
      "class": normalizeClass((_normalizeClass2 = {}, _defineProperty(_normalizeClass2, "".concat(_ctx.className, "__item"), true), _defineProperty(_normalizeClass2, "".concat(_ctx.className, "__item-active"), index === _ctx.current), _normalizeClass2)),
      style: normalizeStyle({
        background: index === _ctx.current ? _ctx.activeColor : _ctx.color
      })
    }, null, 6 /* CLASS, STYLE */);
  }), 128 /* KEYED_FRAGMENT */))], 2 /* CLASS */);
}

script$2.render = render$1;
script$2.__file = "components/src/component/swiper/indicators/common.vue";

var _createComponent$1 = createComponent('swiper-indicator-dots'),
  create$1 = _createComponent$1.create,
  className$1 = _createComponent$1.className;
var script$1 = create$1({
  props: {
    // 当前索引
    current: propTypes.number().def(0),
    // 总数
    count: propTypes.number().def(0),
    // 指示器颜色
    color: propTypes.string().def('rgba(0, 0, 0, 0.5)'),
    // 指示器激活颜色
    activeColor: propTypes.string().def('#000')
  },
  setup: function setup(props) {
    var maxCount = 5;
    var showPreMore = computed(function () {
      if (props.count > maxCount && props.current >= maxCount - 1) {
        return true;
      }
      return false;
    });
    var showNextMore = computed(function () {
      if (props.count > maxCount && props.current < props.count - 2) {
        return true;
      }
      return false;
    });
    var normalCount = computed(function () {
      if (showPreMore.value && showNextMore.value) return maxCount - 2;
      if (showPreMore.value || showNextMore.value) return maxCount - 1;
      return props.count;
    });
    var activeIndex = computed(function () {
      if (!showPreMore.value) {
        return props.current;
      }
      if (!showNextMore.value) {
        return props.current - (props.count - (maxCount - 1));
      }
      return maxCount - 3;
    });
    var itemClassName = "".concat(className$1, "__item");
    var itemMoreClassName = "".concat(className$1, "__item-more");
    var activeClassName = "".concat(className$1, "__item-active");
    return {
      className: className$1,
      itemClassName: itemClassName,
      itemMoreClassName: itemMoreClassName,
      activeClassName: activeClassName,
      showPreMore: showPreMore,
      showNextMore: showNextMore,
      normalCount: normalCount,
      activeIndex: activeIndex
    };
  }
});

function render(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", {
    "class": normalizeClass(_ctx.className)
  }, [_ctx.showPreMore ? (openBlock(), createElementBlock("div", {
    key: 0,
    "class": normalizeClass([_ctx.itemClassName, _ctx.itemMoreClassName]),
    style: normalizeStyle({
      background: _ctx.color
    })
  }, null, 6 /* CLASS, STYLE */)) : createCommentVNode("v-if", true), (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.normalCount, function (value, index) {
    var _normalizeClass2;
    return openBlock(), createElementBlock("div", {
      key: index,
      "class": normalizeClass((_normalizeClass2 = {}, _defineProperty(_normalizeClass2, _ctx.activeClassName, index === _ctx.activeIndex), _defineProperty(_normalizeClass2, _ctx.itemClassName, true), _normalizeClass2)),
      style: normalizeStyle({
        background: index === _ctx.activeIndex ? _ctx.activeColor : _ctx.color
      })
    }, null, 6 /* CLASS, STYLE */);
  }), 128 /* KEYED_FRAGMENT */)), _ctx.showNextMore ? (openBlock(), createElementBlock("div", {
    key: 1,
    "class": normalizeClass([_ctx.itemClassName, _ctx.itemMoreClassName]),
    style: normalizeStyle({
      background: _ctx.color
    })
  }, null, 6 /* CLASS, STYLE */)) : createCommentVNode("v-if", true)], 2 /* CLASS */);
}

script$1.render = render;
script$1.__file = "components/src/component/swiper/indicators/dots.vue";

function scaleEffectDefaultFunction(param) {
  var offset = param.offset,
    minScale = param.minScale,
    slideWidth = param.slideWidth,
    speed = param.speed;
  var scaleMax = 1,
    scaleMin = minScale;
  var scaleDelta = scaleMax - scaleMin;
  // speed数值越大，缩放速度越快，宜在0.5到1之间取值，默认为0.618
  var speedTranslated = speed || 0.618;
  // 使滑到slideWidth的倍数时，正好scale到1
  var normalizeOffset = Math.PI * offset / slideWidth;
  var scale = Math.cos(normalizeOffset) * (scaleDelta * speedTranslated) + (1 - scaleDelta * speedTranslated);
  if (scale >= scaleMax) return scaleMax;
  if (scale <= scaleMin) return scaleMin;
  return scale;
}

var _createComponent = createComponent('swiper'),
  create = _createComponent.create,
  className = _createComponent.className;
/**
 * 循环滚动时创造的影子节点数，左右相同
 */
var SHADOW_ITEM_COUNT = 2;
var script = create({
  props: props,
  emits: emits,
  setup: function setup(props, _ref) {
    var _props$followConfig$s;
    var slots = _ref.slots,
      emit = _ref.emit;
    // 手势阈值
    var halfSlideWidth = 150;
    // 当前轮播元素个数
    var swiperItemsCount = 0;
    // 当前轮播元素实际DOM个数
    var swiperItemsTranslateCount = 0;
    var canLoop = function canLoop() {
      return props.loop && swiperItemsCount > 1;
    };
    var state = reactive({
      // 锚点索引，当前实际的Item索引
      anchorIndex: props.initIndex,
      // 以当前锚点索引为参照的偏移
      anchorOffset: 0,
      // 以当前锚点索引为参照的滑动的方向，1为右，-1为左
      anchorDirection: 1,
      // 当前dom索引(在有影子节点的情况下会和index不同，影响轮播展示)
      translateIndex: canLoop() ? props.initIndex + SHADOW_ITEM_COUNT : props.initIndex,
      // 当前跟手索引（用来计算跟手时的动画）。为跟手Item的dom索引，不为item索引
      followIndex: canLoop() ? props.initIndex + SHADOW_ITEM_COUNT : props.initIndex,
      // 下一个跟手索引。为下一个跟手Item的dom索引，不为item索引
      nextFollowIndex: undefined,
      // 以跟手索引为参照的偏移量
      followOffset: 0,
      // 以跟手索引为参照的滑动的方向，1为右，-1为左
      followDirection: 1,
      // 跨越时的步长
      step: 1,
      // 是否执行动画
      movingAnimation: false
    });
    var swiperRef = ref();
    var minScale = ((_props$followConfig$s = props.followConfig.scale) === null || _props$followConfig$s === void 0 ? void 0 : _props$followConfig$s.minScale) || 1;
    var transformScale = props.followConfig.isFollow && props.followConfig.scale && computed(function () {
      if (minScale < 1) {
        var _props$followConfig$s2, _props$followConfig$s3, _props$followConfig$s4;
        var scaleParam = {
          offset: state.followOffset,
          minScale: minScale,
          slideWidth: 2 * halfSlideWidth,
          speed: ((_props$followConfig$s2 = props.followConfig.scale) === null || _props$followConfig$s2 === void 0 ? void 0 : _props$followConfig$s2.speed) || 0.618
        };
        if ((_props$followConfig$s3 = props.followConfig.scale) !== null && _props$followConfig$s3 !== void 0 && _props$followConfig$s3.func) return (_props$followConfig$s4 = props.followConfig.scale) === null || _props$followConfig$s4 === void 0 ? void 0 : _props$followConfig$s4.func(scaleParam);
        return scaleEffectDefaultFunction(scaleParam);
      }
      return 1;
    });
    var touch = useTouch();
    var touchable = computed(function () {
      return props.touchable;
    });
    /**
     * 对index求余，限制在正确的区间内
     */
    function remainder(index, length) {
      return (index + length) % length;
    }
    function setAnchors(index) {
      var isManual = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var isJump = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      // 限制index不要超出最大长度
      var remainderIndex = remainder(index, swiperItemsCount);
      state.anchorIndex = remainderIndex;
      if (canLoop()) {
        // 限制loop情况下translateIndex不要超出扩展后的长度
        state.translateIndex = remainder(index + SHADOW_ITEM_COUNT, swiperItemsTranslateCount);
      } else {
        state.translateIndex = remainderIndex;
      }
      // 两种情况需要调整跟手索引，一个是非用户拖动中，一个是闪跳
      if (!isManual || isJump) state.followIndex = state.translateIndex;
    }
    function updateNextFollow() {
      if (canLoop()) {
        state.nextFollowIndex = remainder(state.followIndex + state.followDirection * state.step, swiperItemsTranslateCount);
      } else {
        state.nextFollowIndex = remainder(state.followIndex + state.followDirection * state.step, swiperItemsCount);
      }
    }
    // TODO：以下是跨越的代码，暂时注释掉
    // function computeFollows() {
    //     if (canLoop()) {
    //         // 限制loop情况下translateIndex不要超出扩展后的长度
    //         state.followIndex = remainder(
    //             state.translateIndex + state.followDirection * state.step,
    //             swiperItemsTranslateCount
    //         );
    //     } else {
    //         state.followIndex = remainder(
    //             state.translateIndex + state.followDirection * state.step,
    //             swiperItemsCount
    //         );
    //     }
    //     updateNextFollow();
    // }
    function refreshNextFollow() {
      state.nextFollowIndex = undefined;
    }
    /**
     * 轮播图滚动
     * @param index {number} 目标索引
     * @param offset {number} 在目标索引的偏移
     * @param isManual {boolean} 是否在用户拖动中（1. 拖动中会去除css transition，不然会影响性能； 2. 和跟手索引的更新逻辑有关，防止在拖动时调整跟手索引为DOM索引）
     * @param isJump {boolean} 是否闪跳（1. 闪跳会去除css transition，不然达不到闪跳的视觉效果； 2. 和跟手索引的更新逻辑有关，闪跳时需要调整跟手索引为DOM索引）
     */
    function move(index) {
      var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      var isManual = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      var isJump = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
      if (!swiperItemsCount) {
        return;
      }
      state.movingAnimation = !isManual && !isJump;
      state.anchorOffset = offset;
      state.followOffset = offset;
      setAnchors(index, isManual, isJump);
    }
    /**
     * 重置轮播图位置
     */
    function resetPosition() {
      move(state.anchorIndex, 0, true);
    }
    /**
     * 等待Composite完成后再调用
     */
    function runAfterComposite(fn) {
      requestAnimationFrame(function () {
        setTimeout(fn, 1);
      });
    }
    /**
     * 移动到上一张轮播图
     */
    function movePrev() {
      resetPosition();
      runAfterComposite(function () {
        move(state.anchorIndex - 1);
      });
    }
    /**
     * 移动到下一张轮播图
     */
    function moveNext() {
      resetPosition();
      runAfterComposite(function () {
        move(state.anchorIndex + 1);
      });
    }
    /**
     * 自动播放定时器封装
     */
    var autoPlay = useTimer({
      time: props.interval,
      fn: function fn() {
        if (swiperItemsCount) {
          moveNext();
        }
      }
    });
    // 对开始播放轮播进行封装
    function tryStartAutoPlay() {
      if (props.autoPlay) {
        autoPlay.start();
      }
    }
    // 结束播放轮播
    function stopAutoPlay() {
      autoPlay.stop();
    }
    /**
     * 初始化
     */
    function init() {
      tryStartAutoPlay();
      nextTick(function () {
        move(state.anchorIndex, 0, false, true);
      });
    }
    function onTouchStart(e) {
      if (props.isStopPropagation) e.stopPropagation();
      if (props.isPreventDefault) preventDefault(e, false);
      if (!touchable.value) return;
      /* istanbul ignore next */
      if (!swiperRef.value) return;
      // composition-api不支持vue3的 https://github.com/vuejs/composition-api#template-refs，所以暂时使用refs.swiperRef
      // 根据轮播图宽度，设置手势阈值
      halfSlideWidth = swiperRef.value.getBoundingClientRect().width / 2;
      // 循环情况下，跨边界到shadowItem上时，这里会刷新到对应的非shadowItem位置
      move(state.anchorIndex, 0, false, true);
      touch.start(e);
      stopAutoPlay();
      // state.isTouchEnd = false; // TODO：跨越的代码，暂时注释掉
    }

    function onTouchMove(e) {
      if (!touchable.value) return;
      touch.move(e);
      if (touch.state.direction !== 'horizontal') return;
      // 横滑时阻止默认事件，防止上下滑动
      preventDefault(e, false);
      state.followOffset = touch.state.deltaX - (state.step - 1) * state.anchorDirection * 2 * halfSlideWidth; // 剔除跨越量的offSet
      if (!canLoop() && (state.followIndex === 0 && state.followOffset >= 0 || state.followIndex === swiperItemsCount - 1 && state.followOffset <= 0)) {
        // 非loop情况下，限制第一个向前和最后一个向后拖动
        move(state.followIndex, 0, true);
      } else {
        move(state.anchorIndex, touch.state.deltaX, true);
        state.step = 1 ; // TODO：暂时屏蔽掉跨越，待之后开发
        state.anchorDirection = touch.state.deltaX > 0 ? -1 : 1;
        if (touch.state.offsetX < halfSlideWidth * state.step) {
          // 还未发生跨越
          state.followDirection = state.anchorDirection;
          updateNextFollow();
        } else {
          // TODO：以下不是跨越的代码，以后要注释掉
          updateNextFollow();
          // TODO：以下是跨越的代码，暂时注释掉
          // computeFollows();
        }
      }
    }

    function onTouchEnd() {
      // state.isTouchEnd = true; // TODO：跨越的代码，暂时注释掉
      tryStartAutoPlay();
      if (!touchable.value) return;
      if (touch.state.direction !== 'horizontal') return;
      var nextAnchorIndex = state.anchorIndex - (touch.state.deltaX > 0 ? 1 : -1);
      if (!canLoop() && (state.followIndex === 0 && state.followOffset >= 0 || state.followIndex === swiperItemsCount - 1 && state.followOffset <= 0)) {
        // 非loop情况下，限制第一个向前和最后一个向后拖动
        move(state.followIndex);
      }
      // TODO：以下不是跨越的代码，以后要注释掉
      else if (touch.state.offsetX > 15 && touch.speed.x > 0.18 || touch.state.offsetX > halfSlideWidth) {
        // 拖动距离大于10且速度大于2，可以移一步
        move(nextAnchorIndex);
      } else {
        // 没有达到阈值，移回anchor
        move(state.anchorIndex);
      }
      // TODO：以下是跨越的代码，暂时注释掉
      // else if ((touch.state.offsetX > 15 && touch.state.offsetX < halfSlideWidth && touch.speed.x > 0.18)) {
      //     // 拖动距离大于10且速度大于2，可以移一步
      //     move(state.nextFollowIndex);
      //     console.log('拖动距离大于10且速度大于2，可以移一步', state.followIndex);
      // } else {
      //     // 跟手情况
      //     console.log('跟手情况', state.followIndex);
      //     move(state.followIndex);
      // }
      refreshNextFollow();
    }
    // 抛出事件
    watch(function () {
      return state.anchorIndex;
    }, function (val, oldVal) {
      emit(CHANGE_EVENT, val, oldVal);
    });
    if (props.followConfig.isFollow) {
      // TODO：以下是跨越的代码，暂时注释掉
      // watch(
      //     () => state.followIndex,
      //     (val, oldVal) => {
      //         // followIndex因为取的是唯一的DOM索引，因此往外抛的时候需要还原成Item索引，并校验Item索引是否改变
      //         console.log('state.followIndex', val, oldVal);
      //         const cur = canLoop() ? remainder(val - SHADOW_ITEM_COUNT, swiperItemsCount) : val;
      //         const last = canLoop() ? remainder(oldVal - SHADOW_ITEM_COUNT, swiperItemsCount) : oldVal;
      //         if (cur !== last) emit(FOLLOW_CHANGE_EVENT, cur, last);
      //     }
      // );
      watch(function () {
        return state.nextFollowIndex;
      }, function (val, oldVal) {
        // nextFollowIndex因为取的是唯一的DOM索引，因此往外抛的时候需要还原成Item索引，并校验Item索引是否改变
        var cur = canLoop() && val ? remainder(val - SHADOW_ITEM_COUNT, swiperItemsCount) : val;
        var last = canLoop() && oldVal ? remainder(oldVal - SHADOW_ITEM_COUNT, swiperItemsCount) : oldVal;
        if (cur !== last) emit(NEXT_FOLLOW_CHANGE_EVENT, cur, last);
      });
    }
    props.loop && watch(function () {
      return state.translateIndex;
    }, function (val, oldVal) {
      emit(DOM_CHANGE_EVENT, val, oldVal);
    });
    watch(function () {
      return props.autoPlay;
    }, function () {
      tryStartAutoPlay();
    });
    // TODO：以下是跨越的代码，暂时注释掉
    // watch(
    //     // 监听step，来更新followDirection
    //     () => state.step,
    //     (val, oldVal) => {
    //         // 主要是依据step的变化来计算followDirection
    //         if (state.isTouchEnd) {
    //             // 抬手时不计算followDirection
    //             return;
    //         }
    //         const directionStepCurr = state.anchorDirection * val;
    //         const directionStepLast = state.anchorDirection * oldVal;
    //         if (directionStepCurr > directionStepLast) {
    //             state.followDirection = 1;
    //         } else if (directionStepCurr < directionStepLast) {
    //             state.followDirection = -1;
    //         }
    //         console.log(1111, state.followDirection);
    //         computeFollows();
    //     }
    // );
    onMounted(function () {
      init();
    });
    /* istanbul ignore next */
    onActivated(function () {
      init();
    });
    /* istanbul ignore next */
    onDeactivated(function () {
      stopAutoPlay();
    });
    onBeforeUnmount(function () {
      stopAutoPlay();
    });
    /**
     * 对外方法
     */
    useExpose({
      // 向前一个
      prev: function prev() {
        stopAutoPlay();
        movePrev();
        tryStartAutoPlay();
      },
      // 向后一个
      next: function next() {
        stopAutoPlay();
        moveNext();
        tryStartAutoPlay();
      },
      // 向指定index
      to: function to(index) {
        var noAnimation = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        stopAutoPlay();
        if (!noAnimation) {
          resetPosition();
          runAfterComposite(function () {
            move(index);
          });
        } else {
          move(index, 0, true);
        }
        tryStartAutoPlay();
      }
    });
    var getIndicatorComponent = function getIndicatorComponent() {
      if (props.indicator === 'dots') {
        return script$1;
      }
      return script$2;
    };
    return function () {
      var _class2;
      /**
       * 原始轮播列表
       */
      var originSwiperItems = flatVnodes(slots["default"] ? slots["default"]() : []).filter(function (child) {
        return typeof child.type === 'string';
      });
      swiperItemsCount = originSwiperItems.length;
      swiperItemsTranslateCount = canLoop() ? swiperItemsCount + 2 * SHADOW_ITEM_COUNT : swiperItemsCount;
      /**
       * 增加影子节点后的轮播列表
       */
      var swiperItems = _toConsumableArray(originSwiperItems);
      if (swiperItemsCount === 0) {
        var _class;
        /**
         * 如果未传入轮播内容渲染空div
         */
        var comment = h(Comment);
        comment.children = ' 轮播图列表为空 ';
        return h('div', {
          "class": (_class = {}, _defineProperty(_class, "".concat(className), true), _defineProperty(_class, "".concat(className, "-not-hidden"), !props.isOverflowHidden), _class)
        }, [comment]);
      }
      if (swiperItems.length > 0 && canLoop()) {
        var prefixNodes = [];
        var suffixNodes = [];
        for (var i = 0; i < SHADOW_ITEM_COUNT; i++) {
          var realIndex = i % swiperItems.length;
          prefixNodes.unshift(cloneVNode(swiperItems[swiperItems.length - realIndex - 1]));
          suffixNodes.push(cloneVNode(swiperItems[realIndex]));
        }
        swiperItems = [].concat(prefixNodes, _toConsumableArray(swiperItems), suffixNodes);
      }
      // 对所有插入的子节点包一层DIV
      swiperItems = swiperItems.map(function (child, i) {
        var index = ((canLoop() ? i - SHADOW_ITEM_COUNT : i) + swiperItemsCount) % swiperItemsCount;
        if (i === state.followIndex) {
          var activeScale = transformScale ? transformScale.value : 1;
          return h('div', {
            "class": ["".concat(className, "__item"), "".concat(className, "__item-active")],
            style: {
              width: "".concat(100 / swiperItems.length, "%"),
              transform: "scale(".concat(activeScale, ")")
            },
            attrs: {
              'data-index': index
            },
            key: i
          }, [child]);
        } else if (i === state.nextFollowIndex) {
          var nextScale = transformScale ? 1 + minScale - transformScale.value : minScale;
          return h('div', {
            "class": ["".concat(className, "__item"), "".concat(className, "__item-next")],
            style: {
              width: "".concat(100 / swiperItems.length, "%"),
              transform: "scale(".concat(nextScale, ")")
            },
            attrs: {
              'data-index': index
            },
            key: i
          }, [child]);
        }
        return h('div', {
          "class": ["".concat(className, "__item")],
          style: {
            width: "".concat(100 / swiperItems.length, "%"),
            transform: "scale(".concat(minScale, ")")
          },
          attrs: {
            'data-index': index
          },
          key: i
        }, [child]);
      });
      /**
       * 指示器节点
       */
      var indicatorVNode = undefined;
      var defaultIndicatorWrapperClass = "".concat(className, "-indicator-wrapper");
      var indicatorWrapperClasses = [defaultIndicatorWrapperClass, "".concat(defaultIndicatorWrapperClass, "-").concat(props.indicatorPlacement), _defineProperty({}, "".concat(defaultIndicatorWrapperClass, "-space"), props.indicatorSpace), props.indicatorWrapperClass];
      if (slots.indicator && props.indicatorShow) {
        indicatorVNode = h('div', {
          "class": indicatorWrapperClasses
        }, [slots.indicator({
          index: state.anchorIndex,
          count: swiperItemsCount,
          change: move
        })]);
      } else if (props.indicatorShow) {
        indicatorVNode = h('div', {
          "class": indicatorWrapperClasses
        }, [h(getIndicatorComponent(), {
          current: state.anchorIndex,
          count: swiperItemsCount,
          color: props.indicatorColor,
          activeColor: props.indicatorActiveColor
        })]);
      }
      var swiperItemsWrap = h('div', {
        "class": ["".concat(className, "-inner")],
        style: {
          transform: "translateX(calc(-".concat(100 / swiperItems.length * state.translateIndex, "% + ").concat(state.anchorOffset, "px))"),
          willChange: 'transform',
          transition: "all ".concat(state.movingAnimation ? props.duration : 0, "ms"),
          width: "".concat(100 * swiperItems.length, "%")
        }
      }, swiperItems);
      return h('div', {
        "class": (_class2 = {}, _defineProperty(_class2, "".concat(className), true), _defineProperty(_class2, "".concat(className, "-not-hidden"), !props.isOverflowHidden), _class2),
        onTouchstart: onTouchStart,
        onTouchmove: onTouchMove,
        onTouchend: onTouchEnd,
        onTouchcancel: onTouchEnd,
        ref: swiperRef
      }, [swiperItemsWrap, indicatorVNode]);
    };
  }
});

script.__file = "components/src/component/swiper/swiper.vue";

var _Swiper = script;

export { _Swiper as default };
